// import React, { useEffect, useState } from "react";
// import { useHistory, useLocation } from "react-router-dom";
// import * as XLSX from 'xlsx';
// import {
//   Row, Col, Card, Table, Button, Input,
//   notification, Modal, Select, Typography,
//   Space, Tag, Tooltip, Avatar
// } from "antd";
// import axios from "axios";
// import { baseUrl } from "../../config";
// import {
//   DeleteOutlined, FileExcelOutlined,
//   FilterOutlined, EditOutlined, ExclamationCircleOutlined, 
//   PlusOutlined, UserOutlined, BankOutlined, PhoneOutlined,
//   MailOutlined, EnvironmentOutlined, SearchOutlined, ReloadOutlined
// } from "@ant-design/icons";
// import { getPermissions, hasPermission } from '../../components/permissions';
// import '../../assets/styles/custom_style.css';
// import moment from 'moment';
// import BeneficiariesForm from './Form';

// const { confirm } = Modal;
// const { Option } = Select;
// const { Title, Text } = Typography;

// function BeneficiariesList() {
//   const history = useHistory();
//   const location = useLocation();
//   const queryParams = new URLSearchParams(location.search);
  
//   const [beneficiariesList, setBeneficiariesList] = useState([]);
//   const [pagination, setPagination] = useState({});
//   const [currentPage, setCurrentPage] = useState(1);
//   const [limit, setLimit] = useState(20);
//   const [sortField, setSortField] = useState('id');
//   const [sortOrder, setSortOrder] = useState('desc');
//   const [search, setSearch] = useState('');
//   const [loading, setLoading] = useState(false);
  
//   const [filters, setFilters] = useState({
//     name: '',
//     type: '',
//     status: '',
//     city: '',
//     state: '',
//     phone: '',
//     email: ''
//   });

//   // Modal states
//   const [drawerVisible, setDrawerVisible] = useState(false);
//   const [currentBeneficiaryId, setCurrentBeneficiaryId] = useState(null);
//   const [isUpdateMode, setIsUpdateMode] = useState(false);
//   const [showFilter, setShowFilter] = useState(true);

//   const columns = [
//     {
//       title: '#',
//       dataIndex: "key",
//       key: "key",
//       fixed: 'left',
//       width: 60,
//       align: 'center',
//     },
//     {
//       title: 'Name',
//       dataIndex: "name",
//       key: "name",
//       fixed: 'left',
//       width: 200,
//       sorter: true,
//       render: (text, record) => (
//         <div>
//           <Text strong>{text}</Text>
//           <br />
//           <Text type="secondary" style={{ fontSize: '12px' }}>
//             ID: {record.id}
//           </Text>
//         </div>
//       )
//     },
//     {
//       title: 'Type',
//       dataIndex: 'type',
//       key: 'type',
//       width: 120,
//       render: (type) => {
//         const colors = {
//           'Student': 'blue',
//           'Staff': 'green',
//           'Vendor': 'orange',
//           'Gurukul': 'purple',
//           'Other': 'default'
//         };
//         return <Tag color={colors[type] || 'default'}>{type}</Tag>;
//       }
//     },
//     {
//       title: 'Contact',
//       key: 'contact',
//       width: 200,
//       render: (_, record) => (
//         <div>
//           {record.phone && (
//             <div style={{ marginBottom: '4px' }}>
//               <PhoneOutlined style={{ marginRight: '4px', color: '#7a0000' }} />
//               <Text>{record.phone}</Text>
//             </div>
//           )}
//           {record.email && (
//             <div>
//               <MailOutlined style={{ marginRight: '4px', color: '#52c41a' }} />
//               <Text style={{ fontSize: '12px' }}>{record.email}</Text>
//             </div>
//           )}
//         </div>
//       )
//     },
//     {
//       title: 'Location',
//       key: 'location',
//       width: 150,
//       render: (_, record) => (
//         <div>
//           <div>{record.city}</div>
//           <Text type="secondary" style={{ fontSize: '12px' }}>{record.state}</Text>
//         </div>
//       )
//     },
//     {
//       title: 'Bank Details',
//       key: 'bank',
//       width: 180,
//       render: (_, record) => (
//         <div>
//           {record.bank_name && (
//             <div>
//               <BankOutlined style={{ marginRight: '4px' }} />
//               <Text style={{ fontSize: '12px' }}>{record.bank_name}</Text>
//             </div>
//           )}
//           {record.bank_account_no && (
//             <Text type="secondary" style={{ fontSize: '11px' }}>
//               A/c: {record.bank_account_no}
//             </Text>
//           )}
//         </div>
//       )
//     },
//     {
//       title: 'Status',
//       dataIndex: 'status',
//       key: 'status',
//       width: 100,
//       render: (status) => (
//         <Tag color={status === 'Active' ? 'success' : status === 'Inactive' ? 'warning' : 'error'}>
//           {status}
//         </Tag>
//       )
//     },
//     {
//       title: 'Created',
//       dataIndex: 'created_at',
//       key: 'created_at',
//       width: 120,
//       render: (date) => date ? moment(date).format('DD MMM YYYY') : '-'
//     },
//     {
//       title: 'Actions',
//       key: "action",
//       dataIndex: "action",
//       fixed: 'right',
//       width: 120,
//       align: 'center',
//     }
//   ];

//   useEffect(() => {
//     getBeneficiariesList(currentPage, limit, sortField, sortOrder, search, filters);
//   }, []);

//   const getBeneficiariesList = async (page = 1, limit = 20, sortField = 'id', sortOrder = 'desc', search = '', filters = {}) => {
//     try {
//       setLoading(true);
//       const sortParam = `&sortField=${sortField}&sortOrder=${sortOrder}`;
//       const searchParam = search ? `&search=${search}` : '';
//       const filterParams = Object.keys(filters)
//         .filter(key => filters[key])
//         .map(key => `${key}=${filters[key]}`)
//         .join('&');
      
//       const response = await axios.get(
//         `${baseUrl}/beneficiaries/list?page=${page}&limit=${limit}${sortParam}${searchParam}&${filterParams}`,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
//           }
//         }
//       );
      
//       if (response.data.status) {
//         setBeneficiariesList(response.data.result);
//         setPagination({
//           current: page,
//           pageSize: limit,
//           total: response.data.totalCount
//         });
//       }
//     } catch (error) {
//       notification.error({
//         message: 'Error',
//         description: 'Failed to fetch beneficiaries data',
//         placement: 'topRight'
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDelete = async (id) => {
//     try {
//       const response = await axios.delete(`${baseUrl}/beneficiaries/delete/${id}`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
//         },
//       });
//       if (response.status === 200) {
//         getBeneficiariesList(pagination.current, pagination.pageSize, sortField, sortOrder, search, filters);
//         notification.success({
//           message: 'Success',
//           description: 'Beneficiary deleted successfully!',
//           placement: 'topRight'
//         });
//       }
//     } catch (error) {
//       notification.error({
//         message: 'Error',
//         description: 'Failed to delete beneficiary',
//         placement: 'topRight'
//       });
//     }
//   };

//   const showDeleteConfirm = (id, name) => {
//     confirm({
//       title: 'Delete Beneficiary',
//       icon: <ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />,
//       content: `Are you sure you want to delete "${name}"?`,
//       okText: 'Yes, Delete',
//       okType: 'danger',
//       cancelText: 'Cancel',
//       onOk() {
//         handleDelete(id);
//       },
//     });
//   };

//   const showDrawer = (beneficiaryId = null) => {
//     setCurrentBeneficiaryId(beneficiaryId);
//     setIsUpdateMode(!!beneficiaryId);
//     setDrawerVisible(true);
//   };

//   const closeDrawer = () => {
//     setDrawerVisible(false);
//     setCurrentBeneficiaryId(null);
//     setIsUpdateMode(false);
//   };

//   const onRefresh = () => {
//     closeDrawer();
//     getBeneficiariesList(currentPage, limit, sortField, sortOrder, search, filters);
//   };

//   const handleTableChange = (pagination, filters, sorter) => {
//     const { current, pageSize } = pagination;
//     const { field, order } = sorter;
//     const formattedOrder = order === 'ascend' ? 'asc' : 'desc';
    
//     setSortField(field);
//     setSortOrder(formattedOrder);
//     setCurrentPage(current);
//     setLimit(pageSize);
    
//     getBeneficiariesList(current, pageSize, field, formattedOrder, search, filters);
//   };

//   return (
//     <div className="tabled">
//       <Row gutter={[24, 0]}>
//         <Col xs="24" xl={24}>
//           <Card
//             bordered={false}
//             className="criclebox tablespace mb-24"
//             title={
//               <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//                 <UserOutlined style={{ color: '#7a0000', fontSize: '20px' }} />
//                 <Title level={3} style={{ margin: 0, color: '#7a0000' }}>
//                   Beneficiaries Management
//                 </Title>
//               </div>
//             }
//             extra={
//               <Space size="middle">
//                 {hasPermission('/beneficiaries', 'createPermission') && (
//                   <Button
//                     type="primary"
//                     icon={<PlusOutlined />}
//                     onClick={() => showDrawer()}
//                     style={{ borderRadius: '6px' }}
//                   >
//                     Add Beneficiary
//                   </Button>
//                 )}
//                 <Button
//                   icon={<FileExcelOutlined />}
//                   onClick={() => {/* Export logic */}}
//                   style={{ borderRadius: '6px' }}
//                 >
//                   Export Excel
//                 </Button>
//               </Space>
//             }
//           >
//             {/* <div className="table-responsive">
//               <Table
//                 columns={columns}
//                 loading={loading}
//                 scroll={{ x: 'max-content' }}
//                 bordered
//                 size="middle"
//                 dataSource={beneficiariesList.map((beneficiary, index) => ({
//                   key: (limit * (currentPage - 1)) + index + 1,
//                   ...beneficiary,
//                   action: (
//                     <Space size="small">
//                       {hasPermission('/beneficiaries', 'editPermission') && (
//                         <Tooltip title="Edit">
//                           <Button
//                             type="primary"
//                             size="small"
//                             icon={<EditOutlined />}
//                             onClick={() => showDrawer(beneficiary.id)}
//                           />
//                         </Tooltip>
//                       )}
//                       {hasPermission('/beneficiaries', 'deletePermission') && (
//                         <Tooltip title="Delete">
//                           <Button
//                             danger
//                             size="small"
//                             icon={<DeleteOutlined />}
//                             onClick={() => showDeleteConfirm(beneficiary.id, beneficiary.name)}
//                           />
//                         </Tooltip>
//                       )}
//                     </Space>
//                   )
//                 }))}
//                 pagination={{
//                   ...pagination,
//                   showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} beneficiaries`,
//                   showSizeChanger: true,
//                   pageSizeOptions: ['20', '50', '100'],
//                 }}
//                 onChange={handleTableChange}
//               />
//             </div> */}
//             <div className="table-responsive">
//               <Table
//                 columns={columns}
//                 loading={loading}
//                 scroll={{ x: 'max-content' }}
//                 bordered
//                 size="middle"
//                 title={() => (
//                   <div style={{ marginBottom: '16px' }}>
//                     <Row gutter={[16, 16]} align="middle">
//                       <Col>
//                         <Button
//                           icon={<FilterOutlined />}
//                           onClick={() => setShowFilter(!showFilter)}
//                           style={{ borderRadius: '6px' }}
//                         >
//                           {showFilter ? 'Hide Filters' : 'Show Filters'}
//                         </Button>
//                       </Col>
//                       <Col>
//                         <Input
//                           placeholder="Search by name, phone, email..."
//                           value={search}
//                           onChange={e => setSearch(e.target.value)}
//                           onPressEnter={() => getBeneficiariesList(1, limit, sortField, sortOrder, search, filters)}
//                           style={{ width: 300, borderRadius: '6px' }}
//                           suffix={
//                             <SearchOutlined 
//                               onClick={() => getBeneficiariesList(1, limit, sortField, sortOrder, search, filters)} 
//                               style={{ cursor: 'pointer' }} 
//                             />
//                           }
//                         />
//                       </Col>
//                     </Row>

//                     {showFilter && (
//                       <div style={{
//                         marginTop: '16px',
//                         padding: '16px',
//                         background: '#f8f9fa',
//                         borderRadius: '8px',
//                         border: '1px solid #e9ecef'
//                       }}>
//                         <Row gutter={[12, 12]}>
//                           <Col span={6}>
//                             <Select
//                               placeholder="Beneficiary Type"
//                               value={filters.type}
//                               onChange={value => setFilters({...filters, type: value})}
//                               style={{ width: '100%' }}
//                               allowClear
//                             >
//                               <Option value="">All Types</Option>
//                               <Option value="Student">Student</Option>
//                               <Option value="Staff">Staff</Option>
//                               <Option value="Vendor">Vendor</Option>
//                               <Option value="Gurukul">Gurukul</Option>
//                               <Option value="Partner_Organization">Partner Organization</Option>
//                               <Option value="Government">Government</Option>
//                               <Option value="Other">Other</Option>
//                             </Select>
//                           </Col>
//                           <Col span={6}>
//                             <Select
//                               placeholder="Status"
//                               value={filters.status}
//                               onChange={value => setFilters({...filters, status: value})}
//                               style={{ width: '100%' }}
//                               allowClear
//                             >
//                               <Option value="">All Status</Option>
//                               <Option value="Active">Active</Option>
//                               <Option value="Inactive">Inactive</Option>
//                               <Option value="Suspended">Suspended</Option>
//                             </Select>
//                           </Col>
//                           <Col span={6}>
//                             <Input
//                               placeholder="City"
//                               value={filters.city}
//                               onChange={e => setFilters({...filters, city: e.target.value})}
//                             />
//                           </Col>
//                           <Col span={6}>
//                             <Input
//                               placeholder="State"
//                               value={filters.state}
//                               onChange={e => setFilters({...filters, state: e.target.value})}
//                             />
//                           </Col>
//                           <Col span={24}>
//                             <Space>
//                               <Button
//                                 type="primary"
//                                 icon={<SearchOutlined />}
//                                 onClick={() => getBeneficiariesList(1, limit, sortField, sortOrder, search, filters)}
//                                 style={{ borderRadius: '6px' }}
//                               >
//                                 Search
//                               </Button>
//                               <Button
//                                 icon={<ReloadOutlined />}
//                                 onClick={() => {
//                                   setFilters({
//                                     name: '', type: '', status: '', city: '', state: '', phone: '', email: ''
//                                   });
//                                   setSearch('');
//                                   getBeneficiariesList(1, limit, sortField, sortOrder, '', {});
//                                 }}
//                                 style={{ borderRadius: '6px' }}
//                               >
//                                 Reset Filters
//                               </Button>
//                             </Space>
//                           </Col>
//                         </Row>
//                       </div>
//                     )}
//                   </div>
//                 )}
//                 dataSource={beneficiariesList.map((beneficiary, index) => ({
//                   key: (limit * (currentPage - 1)) + index + 1,
//                   ...beneficiary,
//                   action: (
//                     <Space size="small">
//                       <Tooltip title="View Details">
//                         <Button
//                           type="default"
//                           size="small"
//                           icon={<UserOutlined />}
//                           onClick={() => history.push(`/beneficiaries/view/${beneficiary.id}`)}
//                         />
//                       </Tooltip>
//                       {hasPermission('/beneficiaries', 'editPermission') && (
//                         <Tooltip title="Edit">
//                           <Button
//                             type="primary"
//                             size="small"
//                             icon={<EditOutlined />}
//                             onClick={() => showDrawer(beneficiary.id)}
//                           />
//                         </Tooltip>
//                       )}
//                       {hasPermission('/beneficiaries', 'deletePermission') && (
//                         <Tooltip title="Delete">
//                           <Button
//                             danger
//                             size="small"
//                             icon={<DeleteOutlined />}
//                             onClick={() => showDeleteConfirm(beneficiary.id, beneficiary.name)}
//                           />
//                         </Tooltip>
//                       )}
//                     </Space>
//                   )
//                 }))}
//                 pagination={{
//                   ...pagination,
//                   showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} beneficiaries`,
//                   showSizeChanger: true,
//                   pageSizeOptions: ['20', '50', '100'],
//                 }}
//                 onChange={handleTableChange}
//               />
//             </div>
//           </Card>
//         </Col>
//       </Row>

//       {/* Form Modal */}
//       <Modal
//         title={isUpdateMode ? "Update Beneficiary" : "Add Beneficiary"}
//         open={drawerVisible}
//         onCancel={closeDrawer}
//         footer={null}
//         width={800}
//         destroyOnClose
//       >
//         <BeneficiariesForm 
//           beneficiaryId={currentBeneficiaryId} 
//           onRefreshData={onRefresh}
//         />
//       </Modal>
//     </div>
//   );
// }

// export default BeneficiariesList;


import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import * as XLSX from 'xlsx';
import {
  Row, Col, Card, Table, Button, Input,
  notification, Modal, Drawer, Select, Typography,
  Space, Tag, Tooltip, Avatar
} from "antd";
import axios from "axios";
import { baseUrl } from "../../config";
import {
  DeleteOutlined, FileExcelOutlined,
  FilterOutlined, EditOutlined, ExclamationCircleOutlined, 
  PlusOutlined, UserOutlined, BankOutlined, PhoneOutlined,
  MailOutlined, EnvironmentOutlined, SearchOutlined, ReloadOutlined,
  EyeOutlined
} from "@ant-design/icons";
import { getPermissions, hasPermission } from '../../components/permissions';
import '../../assets/styles/custom_style.css';
import moment from 'moment';
import BeneficiariesForm from './Form';
import BeneficiariesView from './View';

const { confirm } = Modal;
const { Option } = Select;
const { Title, Text } = Typography;

function BeneficiariesList() {
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  
  const [beneficiariesList, setBeneficiariesList] = useState([]);
  const [pagination, setPagination] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [sortField, setSortField] = useState('id');
  const [sortOrder, setSortOrder] = useState('desc');
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [types, setTypes] = useState([]);

  const [filters, setFilters] = useState({
    name: '',
    type: '',
    status: '',
    city: '',
    state: '',
    phone: '',
    email: ''
  });

  // Modal states
  const [formModalVisible, setFormModalVisible] = useState(false);
  const [viewModalVisible, setViewModalVisible] = useState(false);
  const [currentBeneficiaryId, setCurrentBeneficiaryId] = useState(null);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [showFilter, setShowFilter] = useState(true);

  const columns = [
    {
      title: '#',
      dataIndex: "key",
      key: "key",
      fixed: 'left',
      width: 60,
      align: 'center',
    },
    {
      title: 'Name',
      dataIndex: "name",
      key: "name",
      fixed: 'left',
      width: 200,
      sorter: true,
      render: (text, record) => (
        <div>
          <Text strong>{text}</Text>
          <br />
          <Text type="secondary" style={{ fontSize: '12px' }}>
            ID: {record.id}
          </Text>
        </div>
      )
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      width: 120,
      render: (type) => {
        const colors = {
          'Student': 'blue',
          'Staff': 'green',
          'Vendor': 'orange',
          'Gurukul': 'purple',
          'Other': 'default'
        };
        return <Tag color={colors[type] || 'default'}>{type}</Tag>;
      }
    },
    {
      title: 'बालक/बालिका',
      key: 'gender',
      width: 110,
      render: (_, record) => {
        if (!record.gender) return <Text type="secondary">-</Text>;
        const isM = record.gender === 'Male';
        return (
          <Tag color={isM ? 'blue' : 'pink'}>
            {isM ? 'बालक' : 'बालिका'}
          </Tag>
        );
      }
    },
    {
      title: 'पारिवारिक स्थिति',
      dataIndex: 'family_status',
      key: 'family_status',
      width: 180,
      render: (v) => v
        ? <Text style={{ fontSize: 12 }}>{v}</Text>
        : <Text type="secondary">-</Text>
    },
    {
      title: 'Contact',
      key: 'contact',
      width: 200,
      render: (_, record) => (
        <div>
          {record.phone && (
            <div style={{ marginBottom: '4px' }}>
              <PhoneOutlined style={{ marginRight: '4px', color: '#7a0000' }} />
              <Text>{record.phone}</Text>
            </div>
          )}
          {record.email && (
            <div>
              <MailOutlined style={{ marginRight: '4px', color: '#52c41a' }} />
              <Text style={{ fontSize: '12px' }}>{record.email}</Text>
            </div>
          )}
        </div>
      )
    },
    {
      title: 'Location',
      key: 'location',
      width: 150,
      render: (_, record) => (
        <div>
          <div>{record.city}</div>
          <Text type="secondary" style={{ fontSize: '12px' }}>{record.state}</Text>
        </div>
      )
    },
    {
      title: 'Bank Details',
      key: 'bank',
      width: 180,
      render: (_, record) => (
        <div>
          {record.bank_name && (
            <div>
              <BankOutlined style={{ marginRight: '4px' }} />
              <Text style={{ fontSize: '12px' }}>{record.bank_name}</Text>
            </div>
          )}
          {record.bank_account_no && (
            <Text type="secondary" style={{ fontSize: '11px' }}>
              A/c: {record.bank_account_no}
            </Text>
          )}
        </div>
      )
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 100,
      render: (status) => (
        <Tag color={status === 'Active' ? 'success' : status === 'Inactive' ? 'warning' : 'error'}>
          {status}
        </Tag>
      )
    },
    {
      title: 'Created',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 120,
      render: (date) => date ? moment(date).format('DD MMM YYYY') : '-'
    },
    {
      title: 'Actions',
      key: "action",
      dataIndex: "action",
      fixed: 'right',
      width: 150,
      align: 'center',
    }
  ];

  useEffect(() => {
    getBeneficiariesList(currentPage, limit, sortField, sortOrder, search, filters);
    loadTypes();
  }, []);

  const loadTypes = async () => {
    try {
      const res = await axios.get(`${baseUrl}/beneficiary-types/list`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
      });
      if (res.data.status) setTypes(res.data.result);
    } catch (_) {}
  };

  const getBeneficiariesList = async (page = 1, limit = 20, sortField = 'id', sortOrder = 'desc', search = '', filters = {}) => {
    try {
      setLoading(true);
      const sortParam = `&sortField=${sortField}&sortOrder=${sortOrder}`;
      const searchParam = search ? `&search=${search}` : '';
      const filterParams = Object.keys(filters)
        .filter(key => filters[key])
        .map(key => `${key}=${filters[key]}`)
        .join('&');
      
      const response = await axios.get(
        `${baseUrl}/beneficiaries/list?page=${page}&limit=${limit}${sortParam}${searchParam}&${filterParams}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          }
        }
      );
      
      if (response.data.status) {
        setBeneficiariesList(response.data.result);
        setPagination({
          current: page,
          pageSize: limit,
          total: response.data.totalCount
        });
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to fetch beneficiaries data',
        placement: 'topRight'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`${baseUrl}/beneficiaries/delete/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      if (response.status === 200) {
        getBeneficiariesList(pagination.current, pagination.pageSize, sortField, sortOrder, search, filters);
        notification.success({
          message: 'Success',
          description: 'Beneficiary deleted successfully!',
          placement: 'topRight'
        });
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to delete beneficiary',
        placement: 'topRight'
      });
    }
  };

  const showDeleteConfirm = (id, name) => {
    confirm({
      title: 'Delete Beneficiary',
      icon: <ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />,
      content: `Are you sure you want to delete "${name}"?`,
      okText: 'Yes, Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk() {
        handleDelete(id);
      },
    });
  };

  const showFormModal = (beneficiaryId = null) => {
    setCurrentBeneficiaryId(beneficiaryId);
    setIsUpdateMode(!!beneficiaryId);
    setFormModalVisible(true);
  };

  const showViewModal = (beneficiaryId) => {
    setCurrentBeneficiaryId(beneficiaryId);
    setViewModalVisible(true);
  };

  const closeFormModal = () => {
    setFormModalVisible(false);
    setCurrentBeneficiaryId(null);
    setIsUpdateMode(false);
  };

  const closeViewModal = () => {
    setViewModalVisible(false);
    setCurrentBeneficiaryId(null);
  };

  const onRefresh = () => {
    closeFormModal();
    getBeneficiariesList(currentPage, limit, sortField, sortOrder, search, filters);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    const { current, pageSize } = pagination;
    const { field, order } = sorter;
    const formattedOrder = order === 'ascend' ? 'asc' : 'desc';
    
    setSortField(field);
    setSortOrder(formattedOrder);
    setCurrentPage(current);
    setLimit(pageSize);
    
    getBeneficiariesList(current, pageSize, field, formattedOrder, search, filters);
  };

  const handleEditFromView = (beneficiaryId) => {
    closeViewModal();
    showFormModal(beneficiaryId);
  };

  return (
    <div className="tabled">
      <Row gutter={[24, 0]}>
        <Col xs="24" xl={24}>
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title={<span style={{ color: '#7a0000', fontWeight: 700, fontSize: 14 }}>Beneficiaries Management</span>}
            headStyle={{ borderBottom: '1.5px solid #e2e8f0' }}
            extra={
              <Space size="small">
                {hasPermission('/beneficiaries', 'createPermission') && (
                  <Button icon={<PlusOutlined />} onClick={() => showFormModal()}
                    style={{ background: '#7a0000', borderColor: '#7a0000', color: '#fff', fontWeight: 600 }}>
                    Add Beneficiary
                  </Button>
                )}
                <Button icon={<FileExcelOutlined />} onClick={() => {}}
                  style={{ borderRadius: 8 }}>
                  Export Excel
                </Button>
              </Space>
            }
          >
            <div className="table-responsive">
              <Table
                columns={columns}
                loading={loading}
                scroll={{ x: 'max-content' }}
                bordered
                size="middle"
                title={() => (
                  <div style={{ marginBottom: '16px' }}>
                    <Row gutter={[16, 8]} align="middle">
                      <Col>
                        <Button
                          icon={<FilterOutlined />}
                          onClick={() => setShowFilter(!showFilter)}
                          style={{ borderRadius: '6px' }}
                        >
                          {showFilter ? 'Hide Filters' : 'Show Filters'}
                        </Button>
                      </Col>
                      <Col>
                        <Input
                          placeholder="Search by name, phone, email..."
                          value={search}
                          onChange={e => setSearch(e.target.value)}
                          onPressEnter={() => getBeneficiariesList(1, limit, sortField, sortOrder, search, filters)}
                          style={{ width: 300, borderRadius: '6px' }}
                          suffix={
                            <SearchOutlined 
                              onClick={() => getBeneficiariesList(1, limit, sortField, sortOrder, search, filters)} 
                              style={{ cursor: 'pointer' }} 
                            />
                          }
                        />
                      </Col>
                    </Row>

                    {showFilter && (
                      <div style={{
                        marginTop: '12px',
                        padding: '16px',
                        background: '#f8f9fa',
                        borderRadius: '8px',
                        border: '1px solid #e9ecef'
                      }}>
                        <Row gutter={[12, 8]}>
                          <Col span={6}>
                            <Select
                              placeholder="Beneficiary Type"
                              value={filters.type || undefined}
                              onChange={value => setFilters({...filters, type: value || ''})}
                              style={{ width: '100%' }}
                              allowClear
                            >
                              {types.map(t => (
                                <Option key={t.id} value={t.name}>{t.name}</Option>
                              ))}
                            </Select>
                          </Col>
                          <Col span={6}>
                            <Select
                              placeholder="Status"
                              value={filters.status}
                              onChange={value => setFilters({...filters, status: value})}
                              style={{ width: '100%' }}
                              allowClear
                            >
                              <Option value="">All Status</Option>
                              <Option value="Active">Active</Option>
                              <Option value="Inactive">Inactive</Option>
                              <Option value="Suspended">Suspended</Option>
                            </Select>
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="City"
                              value={filters.city}
                              onChange={e => setFilters({...filters, city: e.target.value})}
                            />
                          </Col>
                          <Col span={6}>
                            <Input
                              placeholder="State"
                              value={filters.state}
                              onChange={e => setFilters({...filters, state: e.target.value})}
                            />
                          </Col>
                          <Col span={24}>
                            <Space style={{ marginTop: '8px' }}>
                              <Button
                                icon={<SearchOutlined />}
                                onClick={() => getBeneficiariesList(1, limit, sortField, sortOrder, search, filters)}
                                style={{ background: '#7a0000', borderColor: '#7a0000', color: '#fff', borderRadius: '6px' }}
                              >
                                Search
                              </Button>
                              <Button
                                icon={<ReloadOutlined />}
                                onClick={() => {
                                  setFilters({
                                    name: '', type: '', status: '', city: '', state: '', phone: '', email: ''
                                  });
                                  setSearch('');
                                  getBeneficiariesList(1, limit, sortField, sortOrder, '', {});
                                }}
                                style={{ borderRadius: '6px' }}
                              >
                                Reset Filters
                              </Button>
                            </Space>
                          </Col>
                        </Row>
                      </div>
                    )}
                  </div>
                )}
                dataSource={beneficiariesList.map((beneficiary, index) => ({
                  key: (limit * (currentPage - 1)) + index + 1,
                  ...beneficiary,
                  action: (
                    <Space size={4}>
                      <Button size="small" icon={<EyeOutlined />} onClick={() => showViewModal(beneficiary.id)}>View</Button>
                      {hasPermission('/beneficiaries', 'editPermission') && (
                        <Button size="small" icon={<EditOutlined />} onClick={() => showFormModal(beneficiary.id)}
                          style={{ background: '#7a0000', borderColor: '#7a0000', color: '#fff' }}>Edit</Button>
                      )}
                      {hasPermission('/beneficiaries', 'deletePermission') && (
                        <Button danger size="small" icon={<DeleteOutlined />} onClick={() => showDeleteConfirm(beneficiary.id, beneficiary.name)}>Delete</Button>
                      )}
                    </Space>
                  )
                }))}
                pagination={{
                  ...pagination,
                  showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} beneficiaries`,
                  showSizeChanger: true,
                  pageSizeOptions: ['20', '50', '100'],
                }}
                onChange={handleTableChange}
              />
            </div>
          </Card>
        </Col>
      </Row>

      {/* Form Drawer */}
      <Drawer
        title={<span style={{ fontWeight: 700, color: '#7a0000' }}>{isUpdateMode ? "Update Beneficiary" : "Add Beneficiary"}</span>}
        width={1000}
        open={formModalVisible}
        onClose={closeFormModal}
        destroyOnClose
        headerStyle={{ borderBottom: '1.5px solid #e2e8f0' }}
        
      >
        <BeneficiariesForm
          beneficiaryId={currentBeneficiaryId}
          onRefreshData={onRefresh}
        />
      </Drawer>

      {/* View Drawer */}
      <Drawer
        title={<span style={{ fontWeight: 700, color: '#7a0000' }}>Beneficiary Details</span>}
        width={900}
        open={viewModalVisible}
        onClose={closeViewModal}
        destroyOnClose
      >
        <BeneficiariesView
          beneficiaryId={currentBeneficiaryId}
          onEdit={handleEditFromView}
          isModal={true}
        />
      </Drawer>
    </div>
  );
}

export default BeneficiariesList;